import { useBlockingRouter } from '../../../hooks/useBlockingRouter';

// Markup
import { Icon } from '../../../blocks/icons';
import { Box, Typography } from '@mui/material';
import { Button } from '../../Button';
import { beginUserRegistration } from '../../../redux/actions';
import { OrgOnboardingSteps } from '../../OrgOnboarding/OrgOnboarding';
import { useDispatch } from 'react-redux';
import { ClientOnboardingSteps } from '../../ClientOnboarding';
import { SignUpPage_GetVerificationTokenQuery } from '#types';
import styles from './ChooseUserType.module.scss';

export type ChooseUserTypeProps = {
	coreUserFields: {
		email?: string;
		password: string;
		rePassword: string;
	};
	verificationToken: SignUpPage_GetVerificationTokenQuery['getVerificationToken'];
	promoCode?: string;
};

export const ChooseUserType = ( {
	coreUserFields,
	verificationToken,
	promoCode,
}: ChooseUserTypeProps ) => {
	const dispatch = useDispatch();
	const router = useBlockingRouter();
	const registerAndRoute = ( destinationPath: string ) => {
		dispatch(
			beginUserRegistration( {
				coreUserFields,
				verificationToken,
				promoCode,
			} )
		);
		router.push( destinationPath );
	};

	return (
		<Box component='main' className={ styles.container }>
			<Typography variant='h1' className={ styles.heading }>
				Let’s get started. What is your role?
			</Typography>
			<Box className={ styles.buttonContainer }>
				<Button
					id='organization-select'
					className={ styles.selectionButton }
					variant='outlined'
					onClick={ () =>
						registerAndRoute( `/orgOnboarding/${ OrgOnboardingSteps.YourInfo }` )
					}
				>
					<Icon type='vendor' />
					<Typography className={ `${ styles.selectionButtonText } p--large` }>
						I'm a business
					</Typography>
				</Button>
				<Box className={ styles.verticalRule } />
				<Button
					id='client-select'
					className={ styles.selectionButton }
					variant='outlined'
					onClick={ () =>
						registerAndRoute(
							`/clientOnboarding/${ ClientOnboardingSteps.YourInfo }`
						)
					}
				>
					<Icon type='client' />
					<Typography className='p--large'>I'm a client</Typography>
				</Button>
			</Box>
		</Box>
	);
};
